import React from "react";

export default function Math_Matrices() {
  return (
    <div>
      <h1>Math_Matrices</h1>
      <p>This is the Math_Matrices component.</p>
    </div>
  );
}
